import { render, staticRenderFns } from "./PhoneFormView.vue?vue&type=template&id=79987404&scoped=true&"
import script from "./PhoneFormView.vue?vue&type=script&lang=js&"
export * from "./PhoneFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79987404",
  null
  
)

export default component.exports